<div class="container">
  <div class="content first-content">
    <div class="first-column">
      <h2 class="title title-primary">Login</h2>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="empresaLogin.email">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Senha</mat-label>
        <input matInput [(ngModel)]="empresaLogin.senha">
      </mat-form-field>
      <p><a class="password" href="#">Esqueceu a senha?</a></p>
      <button id="signin" class="btn btn-primary" (click)="fazerloginEmpresa()">Entrar</button>
    </div>
    <div class="second-column">
      <h2 class="title title-second">Criar Conta</h2>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Empresa</mat-label>
        <input matInput [(ngModel)]="empresa.nome">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>CNPJ</mat-label>
        <input matInput [(ngModel)]="empresa.cnpj">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Telefone</mat-label>
        <input matInput [(ngModel)]="empresa.telefone" placeholder="Telefone">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="empresa.email" placeholder="Email">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Senha</mat-label>
        <input matInput [(ngModel)]="empresa.senha" placeholder="Senha">
      </mat-form-field>
      <button class="btn btn-second" (click)="inserirEmpresa()">Cadastrar</button>
    </div><!-- second column -->
  </div><!-- first content -->
</div>
